export default {
    service: [],
    serviceFiltros: [],
    serviceMovimientos: [],
    serviceMovimientosFiltered: []
}